import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-castemastercreation-grid',
  templateUrl: './castemastercreation-grid.component.html',
  styleUrls: ['./castemastercreation-grid.component.css']
})
export class CastemastercreationGridComponent implements OnInit {
title="Caste Master"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/castemastercreation-grid/castemastercreation-grid.component.ts